import { FC } from 'react';

import { OrderItem } from '../../interfaces/Order';
import { getDeliveryDate, getDeliveryTimeWindow } from '../../utils/dateTimeUtils';

import OrderListItemImage from './OrderListItemImage';

interface IServiceOrderListItemProps {
  item: OrderItem;
}

const ServiceOrderListItem: FC<IServiceOrderListItemProps> = ({
  item: { salesItem: item, orderLine },
}) => {
  const {
    itemKey: { itemNo },
    localisedCommunications,
  } = item;
  const { deliveryTimeWindows, itemName } = orderLine;

  const getServiceItemName = () => {
    const localisedCommunicationsName = localisedCommunications?.[0]?.productType?.name || '';

    return itemName
      ? itemName
      : localisedCommunicationsName.replace(/^\w/, (c: string) => c.toUpperCase());
  };

  return (
    <li className="ServiceOrderListItem flex my-100" key={itemNo}>
      <OrderListItemImage item={item} />

      <div>
        <strong className="text-s">{getServiceItemName()}</strong>

        {!!deliveryTimeWindows &&
          deliveryTimeWindows.map((timeWindow) => (
            <div
              key={`${timeWindow.fromLocalDateTime}-${timeWindow.fromLocalDateTime}`}
              className="ServiceOrderListItem__item-no text-s text-muted"
            >
              <p>
                {getDeliveryDate(timeWindow)}, {getDeliveryTimeWindow(timeWindow)}
              </p>
            </div>
          ))}
      </div>
    </li>
  );
};

export default ServiceOrderListItem;
